import React from 'react'

const LabTagSkeleton = ({ isFirst }) => {
  return (
    <div
      className={`h-12 w-full max-w-36 lg:max-w-full ${
        isFirst
          ? 'bg-blue/10 text-blue font-semibold border-l-3 border-blue -ml-[1px]'
          : 'text-[#1E2144] bg-[#abaed5]/10 hover:text-blue'
      } animate-pulse`}></div>
  )
}

export default LabTagSkeleton
